import * as d3 from 'd3'
import Chart from '../../ultils/Chart'
import emptyThumb from '../../assets/images/emptydata.svg'
import './styles.css'
import d3tip from '../../ultils/d3-tip'
import {
  countYAxisTick,
  FUNDAMENTAL_TOGGLE_COLOR,
} from '../../ultils/chart-d3-utils'
import { PERCENT_CHANGE_ASSET_VOLATILITY, PERCENT_CHANGE_LEVERAGE } from "../../ultils/dataUtil";

const NORMAL = 2

class DriverChart extends Chart {
  init({ data, relations, setSelection, lineKeys, inModal, chartId }) {
    let vis = this
    vis.data = data
    vis.toolTipMode = NORMAL
    vis.lineKeys = lineKeys
    vis.relations = relations
    vis.setSelection = setSelection

    vis.inModal = inModal
    vis.chartId = chartId

    vis.parseTime = d3.timeParse('%d/%m/%Y')
    vis.formatTime = d3.timeFormat('%d/%m/%Y')
    vis.bisectDate = d3.bisector(d => d.date).left

    vis.svg
      .append('defs')
      .append('clipPath')
      .attr('id', 'clip')
      .append('rect')
      .attr('x', 0)
      .attr('width', vis.WIDTH)
      .attr('height', vis.HEIGHT)

    vis.g
      .append('path')
      .attr('class', 'line1')
      .attr('fill', 'none')
      .attr('stroke', 'grey')
      .attr('stroke-width', '3px')

    vis.g
      .append('path')
      .attr('class', 'line2')
      .attr('fill', 'none')
      .attr('stroke', 'grey')
      .attr('stroke-width', '3px')

    vis.g
      .append('path')
      .attr('class', 'line3')
      .attr('fill', 'none')
      .attr('stroke', 'grey')
      .attr('stroke-width', '3px')

    vis.x = d3.scaleTime()
    vis.yVolatility = d3.scaleLinear()
    vis.yLeverage = d3.scaleLinear()
    vis.ymarketAsset = d3.scaleLinear()

    vis.xAxisCall = d3
      .axisBottom()
      .ticks(inModal ? 8 : 2)
      .tickSizeOuter(0)
    vis.yAxisLeftCall = d3
      .axisLeft()
      .ticks(inModal ? 6 : 4)
      .tickSizeOuter(0)
    vis.yAxisRightCall = d3
      .axisRight()
      .ticks(inModal ? 6 : 4)
      .tickSizeOuter(0)

    vis.xAxis = vis.g
      .append('g')
      .attr('class', 'x axisDriverChart')
      .attr('transform', `translate(0, ${vis.HEIGHT})`)
    vis.yAxisLeft = vis.g
      .append('g')
      .attr('class', 'y axisDriverChart yAxisLeftDriverChart')
    vis.yAxisRight = vis.g
      .append('g')
      .attr('class', 'y axisDriverChart yAxisRightDriverChart')

    vis.focus = vis.g
      .append('g')
      .attr('class', 'focus')
      .style('display', 'none')

    vis.yLegend = vis.svg
      .append('text')
      .attr('class', inModal ? 'axis-label label-in-modal' : 'axis-label')
      .attr('text-anchor', 'end')
      .attr('x', inModal ? 110 : 50)
      .attr('y', 10)
    vis.createToolTip()
    vis.update({ data, lineKeys })
  }

  formatPercentageNumber(number) {
    return !isNaN(number) ? Number(number * 100).toFixed(2) * 1 : number
  }

  formatEquityNumber(number) {
    return !isNaN(number) ? Number(number).toFixed(2) : number
  }

  formatNumber(number) {
    const vis = this
    const x = vis.formatAbbreviation(number)
    return !isNaN(number) ? `$${x}` : 'N/A'
  }

  formatAbbreviation(x) {
    const formatSi = d3.format('.3s')
    const s = formatSi(x)
    switch (s[s.length - 1]) {
      case 'G':
        return `${s.slice(0, -1)}B` // billions
      case 'k':
        return `${s.slice(0, -1)}K` // thousands
      case 'M':
        return `${s.slice(0, -1)}M` // thousands
    }
    return s
  }

  createToolTip() {
    const vis = this
    const inModal = vis.inModal ? '-inModal' : '-notInModal'
    d3.selectAll(`.line-chart${vis.chartId}${inModal}`).remove()
    vis.tip = d3tip()
      .attr(
        'class',
        `d3-tip-driver-chart d3-credit-line-chart line-chart${vis.chartId}${inModal}`,
      )
      .html((e, d) => vis.generateTooltipHtml(d))
    vis.g.call(vis.tip)
  }

  generateTooltipHtml(data) {
    const vis = this
    let returnDiv = `<div class="tip-content">`
    if (
      data.hasOwnProperty(vis.getLineKeyValue('equity_price')) &&
      vis.toolTipMode === NORMAL
    ) {
      returnDiv += `<div class="row">
                        <div class="line-chart-row-title">
                          <span class="dot" style="background-color: ${
                            FUNDAMENTAL_TOGGLE_COLOR.EQUITY_PRICE
                          }"></span> Equity Price: 
                        </div>
                      <div class="line-chart-row-content">${vis.formatEquityNumber(
                        data[vis.getLineKeyValue('equity_price')],
                      )}</div>
                      </div>`
    }

    if (
        data.hasOwnProperty(vis.getLineKeyValue('asset_market_value')) &&
        vis.toolTipMode === NORMAL
    ) {
      returnDiv += `<div class="row">
                        <div class="line-chart-row-title">
                          <span class="dot" style="background-color: ${
          FUNDAMENTAL_TOGGLE_COLOR.MARKET_VALUE_OF_ASSET
      }"></span> $USD Market Value of Asset: 
                        </div>
                        <div class="line-chart-row-content">${vis.formatNumber(
          data[vis.getLineKeyValue('asset_market_value')],
      )}</div>
                      </div>`
    }

    if (
      data.hasOwnProperty(vis.getLineKeyValue('leverage')) &&
      vis.toolTipMode === NORMAL
    ) {
      returnDiv += `<div class="row">
                        <div class="line-chart-row-title">
                          <span class="dot" style="background-color: ${
                            FUNDAMENTAL_TOGGLE_COLOR.LEVERAGE
                          }"></span> Market Value of Leverage: 
                        </div>
                      <div class="line-chart-row-content">${vis.formatPercentageNumber(
                        data[vis.getLineKeyValue('leverage')],
                      )} %</div>
                      </div>`
    }

    if (
        data.hasOwnProperty(vis.getLineKeyValue('asset_volatility')) &&
        vis.toolTipMode === NORMAL
    ) {
      returnDiv += `<div class="row">
                        <div class="line-chart-row-title">
                          <span class="dot" style="background-color: ${
          FUNDAMENTAL_TOGGLE_COLOR.ASSET_VOLATILITY
      }"></span> Asset Volatility: 
                        </div>
                      <div class="line-chart-row-content">${vis.formatPercentageNumber(
          data[vis.getLineKeyValue('asset_volatility')],
      )} %</div>
                      </div>`
    }

    returnDiv += `</div></div></div>`
    return returnDiv
  }

  mousemove(e) {
    let vis = this
    if (vis.data.length > 0) {
      const x0 = vis.x.invert(d3.pointer(e)[0] - vis.MARGIN.LEFT)
      const i = vis.bisectDate(vis.data, x0, 1, vis.data.length - 1)
      const d0 = vis.data[i - 1]
      const d1 = vis.data[i]
      const d = x0 - d0.date > d1.date - x0 ? d1 : d0

      if (vis.toolTipMode === NORMAL) {
        vis.focus.selectAll('.x-hover-line').remove()
        vis.focus
          .append('line')
          .attr('class', 'x-hover-line hover-line')
          .attr('y1', 0)
          .attr('y2', vis.HEIGHT)
        vis.focus
          .select('.x-hover-line')
          .attr('x1', vis.x(d.date))
          .attr('x2', vis.x(d.date))

        vis.focus.selectAll('circle').remove()

        if (d.hasOwnProperty(vis.getLineKeyValue('asset_volatility'))) {
          vis.focus
            .append('circle')
            .attr('class', 'asset_volatility')
            .attr('r', 4)
            .attr('fill', FUNDAMENTAL_TOGGLE_COLOR.ASSET_VOLATILITY)
          vis.focus
            .select('.asset_volatility')
            .attr('cx', vis.x(d.date))
            .attr(
              'cy',
              vis.yVolatility(d[vis.getLineKeyValue('asset_volatility')]),
            )
        }

        if (d.hasOwnProperty(vis.getLineKeyValue('leverage'))) {
          vis.focus
            .append('circle')
            .attr('class', 'leverage')
            .attr('r', 4)
            .attr('fill', FUNDAMENTAL_TOGGLE_COLOR.LEVERAGE)
          vis.focus
            .select('.leverage')
            .attr('cx', vis.x(d.date))
            .attr('cy', vis.yLeverage(d[vis.getLineKeyValue('leverage')]))
        }

        if (d.hasOwnProperty(vis.getLineKeyValue('asset_market_value'))) {
          vis.focus
            .append('circle')
            .attr('class', 'asset_market_value')
            .attr('r', 4)
            .attr('fill', FUNDAMENTAL_TOGGLE_COLOR.MARKET_VALUE_OF_ASSET)
          vis.focus
            .select('.asset_market_value')
            .attr('cx', vis.x(d.date))
            .attr(
              'cy',
              vis.ymarketAsset(
                vis.marketAssetScale(
                  d[vis.getLineKeyValue('asset_market_value')],
                ),
              ),
            )
        }
      } else {
        vis.focus.selectAll('circle').remove()
        vis.focus.selectAll('.x-hover-line').remove()
      }

      vis.tip.show(e, d, 10, -d3.pointer(e)[1] - 2)
    }
  }

  getLineKeyValue(key) {
    const vis = this
    const index = vis.lineKeys[vis.lineKeys.indexOf(key)]
    return index
  }

  getCreditScale(property) {
    const vis = this
    let max = d3.max(vis.data, d => d[vis.getLineKeyValue(property)])
    let min = d3.min(vis.data, d => d[vis.getLineKeyValue(property)])
    if(property === 'asset_volatility') {
      max = max + (max * PERCENT_CHANGE_ASSET_VOLATILITY)
      min = min - (min * PERCENT_CHANGE_ASSET_VOLATILITY)
    }
    if(property === 'leverage') {
      max = max + (max * PERCENT_CHANGE_LEVERAGE)
      min = min - (min * PERCENT_CHANGE_LEVERAGE)
    }
    if (min == 0.001 && max == 0.001) {
      // to draw the line at the bottom and hugging xAxis instead of the middle
      max = 0.002
    }
    return [min, max]
  }

  update({ data, lineKeys }) {
    let vis = this
    vis.data = data || vis.data
    vis.lineKeys = lineKeys || vis.lineKeys
    vis.t = d3.transition().duration(1000)
    vis.svg.selectAll('image').remove()

    if (vis.data.length <= 1) {
      // treat 1 record as empty state to clear xAxis & yAxis value
      vis.data = []
      vis.svg
        .append('svg:image')
        .attr('xlink:href', emptyThumb)
        .attr('x', vis.WIDTH / 2 - 77 + vis.MARGIN.LEFT)
        .attr('y', vis.HEIGHT / 2 - 37 + vis.MARGIN.TOP)
        .attr('width', '155')
        .attr('height', '73')
      vis.yLegend.text('')
    }

    // getting range value for xAxis based on pod & peer_pod value
    vis.volatilityRange = vis.getCreditScale('asset_volatility')
    vis.leverageRange = vis.getCreditScale('leverage')
    vis.marketAssetRange = vis.getCreditScale('asset_market_value')

    vis.x.range([0, vis.WIDTH]).domain(d3.extent(vis.data, d => d.date))
    vis.yVolatility.range([vis.HEIGHT, 0]).domain(vis.volatilityRange)
    vis.yLeverage.range([vis.HEIGHT, 0]).domain(vis.leverageRange)
    vis.ymarketAsset.range([vis.HEIGHT, 0]).domain(vis.marketAssetRange)
    vis.yAxisRight.attr('transform', `translate(${vis.WIDTH}, 0)`)

    vis.xAxisCall = d3
      .axisBottom()
      .ticks(countYAxisTick(vis.data))
      .tickSizeOuter(0)
    vis.xAxisCall.scale(vis.x)
    vis.xAxis.transition(vis.t).call(vis.xAxisCall)

    // set right y-axis
    if (
      vis.volatilityRange[0] &&
      vis.leverageRange[0] &&
      vis.marketAssetRange[0]
    ) {
      vis.yAxisRightCall.scale(vis.yLeverage)
      vis.yAxisRightCall.tickFormat(function (d) {
        return !vis.leverageRange[0] ? `` : `${vis.formatPercentageNumber(d)} %`
      })
      vis.yAxisRight.transition(vis.t).call(vis.yAxisRightCall)
      vis.g
        .select('.yAxisRightDriverChart')
        .attr(
          'class',
          'y axisDriverChart yAxisRightDriverChart marketLeverageColor',
        )
    } else if (vis.volatilityRange[0]) {
      vis.yAxisRightCall.scale(vis.yVolatility)
      vis.yAxisRightCall.tickFormat(function (x) {
        return `${vis.formatPercentageNumber(x)} %`
      })
      vis.yAxisRight.transition(vis.t).call(vis.yAxisRightCall)
      vis.g
        .select('.yAxisRightDriverChart')
        .attr(
          'class',
          'y axisDriverChart yAxisRightDriverChart assetVolatilityColor',
        )
    } else {
      vis.yAxisRightCall.scale(vis.yLeverage)
      vis.yAxisRightCall.tickFormat(function (d) {
        return !vis.leverageRange[0] ? `` : `${vis.formatPercentageNumber(d)} %`
      })
      vis.yAxisRight.transition(vis.t).call(vis.yAxisRightCall)
      vis.g
        .select('.yAxisRightDriverChart')
        .attr(
          'class',
          'y axisDriverChart yAxisRightDriverChart marketLeverageColor',
        )
    }

    // set left y-axis
    // if volatility disable & leverage enable & asset enable
    if (
      vis.volatilityRange[0] &&
      vis.leverageRange[0] &&
      !vis.marketAssetRange[0]
    ) {
      vis.yAxisLeftCall.scale(vis.yLeverage)
      vis.yAxisLeftCall.tickFormat(function (d) {
        return `${vis.formatPercentageNumber(d)} %`
      })
      vis.yAxisLeft.transition(vis.t).call(vis.yAxisLeftCall)
      vis.g
        .select('.yAxisLeftDriverChart')
        .attr(
          'class',
          'y axisDriverChart yAxisLeftDriverChart marketLeverageColor',
        )
    } else {

      vis.yAxisLeftCall.scale(vis.ymarketAsset)
      vis.yAxisLeftCall.tickFormat(function (x) {
        return vis.formatAbbreviation(x)
      })
      vis.yAxisLeft.transition(vis.t).call(vis.yAxisLeftCall)
      vis.g
          .select('.yAxisLeftDriverChart')
          .attr(
              'class',
              'y axisDriverChart yAxisLeftDriverChart assetValueColor',
          )
    }

    vis.marketAssetScale = d3
      .scaleLinear()
      .range(vis.marketAssetRange)
      .domain([
        d3.min(vis.data, d =>
          Number(d[vis.getLineKeyValue('asset_market_value')]),
        ) * 0.9,
        d3.max(vis.data, d =>
          Number(d[vis.getLineKeyValue('asset_market_value')]),
        ) * 1.05,
      ])

    vis.marketAssetLine = d3
      .line()
      .curve(d3.curveCatmullRom)
      .defined(d => !isNaN(d[vis.getLineKeyValue('asset_market_value')]))
      .x(d => vis.x(d.date))
      .y(d =>
        vis.ymarketAsset(
          vis.marketAssetScale(d[vis.getLineKeyValue('asset_market_value')]),
        ),
      )

    vis.g
      .select('.line1')
      .attr('stroke-width', '2px')
      .attr('stroke', FUNDAMENTAL_TOGGLE_COLOR.MARKET_VALUE_OF_ASSET)
      .transition(vis.t)
      .attr('d', vis.marketAssetLine(vis.data))

    vis.volatilityLine = d3
      .line()
      .curve(d3.curveCatmullRom)
      .defined(d => !isNaN(d[vis.getLineKeyValue('asset_volatility')]))
      .x(d => vis.x(d.date))
      .y(d => vis.yVolatility(d[vis.getLineKeyValue('asset_volatility')]))

    vis.g
      .select('.line2')
      .attr('stroke-width', '2px')
      .attr('stroke', FUNDAMENTAL_TOGGLE_COLOR.ASSET_VOLATILITY)
      .attr('opacity', 0.9)
      .transition(vis.t)
      .attr('d', vis.volatilityLine(vis.data))

    vis.leverageLine = d3
      .line()
      .curve(d3.curveCatmullRom)
      .defined(d => !isNaN(d[vis.getLineKeyValue('leverage')]))
      .x(d => vis.x(d.date))
      .y(d => vis.yLeverage(d[vis.getLineKeyValue('leverage')]))

    vis.g
      .select('.line3')
      .attr('stroke-width', '2px')
      .attr('stroke', FUNDAMENTAL_TOGGLE_COLOR.LEVERAGE)
      .attr('opacity', 0.9)
      .transition(vis.t)
      .attr('d', vis.leverageLine(vis.data))

    vis.svg
      .on('mousemove', e => vis.mousemove(e))
      .on('mouseover', () => {
        // vis.tip.hide()
        vis.focus.style('display', null)
        !vis.inModal && vis.setSelection(vis.relations)
      })
      .on('mouseout', () => {
        vis.tip.hide()
        vis.focus.style('display', 'none')
        !vis.inModal && vis.setSelection(null)
      })
  }
}

export default DriverChart
